/**
 * PayerSelector Component
 *
 * A card-based selector for choosing payer type (Guest or Corporate).
 *
 * @props
 *  - value: string → current selected payer type
 *  - onChange: function → callback to update selected payer type
 *
 * @example
 * <PayerSelector value={payerType} onChange={setPayerType} />
 */

import React,{useContext} from 'react';
import { Card } from 'antd';
import { UserOutlined, BankOutlined, CheckOutlined } from '@ant-design/icons';
import './payer-selector.scss';
import { Appointments } from '../../../models';
import { payerAvailableTypes } from '..';
import { GlobalContext } from 'soxo-bootstrap-core';



// Individual card for a payer type
const PayerCard = ({ icon, label, value, selectedValue, onChange }) => {
    const isActive = value === selectedValue; // Check if this card is currently selected



    return (
        <Card
            className={`payer-card ${isActive ? 'active' : ''}`}
            onClick={() => {
                onChange(value);
            }}
        >
            <div className="payer-content">
                <div className="payer-label">
                    {icon} {label}
                </div>
                <div className={`custom-radio ${isActive ? 'checked' : ''}`}>{isActive && <CheckOutlined className="tick" />}</div>
            </div>
        </Card>
    );
};

// Main selector rendering all payer cards
const PayerSelector = ({ value, onChange }) => {

    //variable to get the settings
    const { settings } = useContext(GlobalContext);

    //variable to show the guest button or corporate button
    const { enableCorporateAdvance,enableGuestAdvance } = settings?.ADVSET || {};

    return (
        <div className="payer-selector">
            {/* disabling the feature of 11-11-2025 */}
            {(enableGuestAdvance &&
            <PayerCard
                icon={<UserOutlined style={{ marginRight: 8 }} />}
                label="General Guest"
                value={payerAvailableTypes.GUEST}
                selectedValue={value}
                onChange={onChange}
            />
            )}
            {(enableCorporateAdvance  &&
            <PayerCard
                icon={<BankOutlined style={{ marginRight: 8 }} />}
                label="Corporate"
                value={payerAvailableTypes.CORPORATE}
                selectedValue={value}
                onChange={onChange}
            />
            )}
        </div>
    );
};

export default PayerSelector;
